/*!
 * (C) Phonero UX - ISC License
 */
const keyMap = {
  minWidth: "min-width",
  maxWidth: "max-width",
};
function mediaQuerySizeToString(m, seperator = " and ") {
  return Object.keys(m)
    .map((q) => {
    const key = keyMap[q];
    if (!key) {
      return "";
    }
    const v = m[q];
    const value = typeof v === "string" ? v : v + "px";
    return `(${key}: ${value})`;
  })
    .join(seperator);
}
const mediaQueries = {
  xs: { minWidth: 0 },
  s: { minWidth: 375 },
  sm: { minWidth: 576 },
  md: { minWidth: 768 },
  lg: { minWidth: 992 },
  xl: { minWidth: 1200 },
};
const orderedMediaQueries = [
  mediaQueries.xs,
  mediaQueries.s,
  mediaQueries.sm,
  mediaQueries.md,
  mediaQueries.lg,
  mediaQueries.xl,
];
const SIZE_TO_MEDIA = Object.keys(mediaQueries).reduce((r, key) => {
  r[key] = mediaQuerySizeToString(mediaQueries[key]);
  return r;
}, {
  "": undefined,
});
// Check if the window matches the media query
// at the breakpoint passed
// e.g. matchBreakpoint('sm') => true if screen width exceeds 576px
const matchBreakpoint = (breakpoint) => {
  if (breakpoint === undefined || breakpoint === "") {
    return true;
  }
  if (window.matchMedia) {
    const mediaQuery = SIZE_TO_MEDIA[breakpoint];
    return window.matchMedia(mediaQuery).matches;
  }
  return false;
};

export { SIZE_TO_MEDIA as S, mediaQueries as a, matchBreakpoint as b, mediaQuerySizeToString as m, orderedMediaQueries as o };
